import React from 'react';

import { Container, Text } from "basis";
import { LineChart, Line, XAxis, YAxis, Label, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const LineGraph = ({ title, chartData, yLabel, xDataKey, lineDataKeys, showLegend }) => {
  return (
    <>
      <Container bg="white" padding="4" height="240">
        <Container margin="0 0 4 2">
          <Text as="h5" textStyle="heading5">{title}</Text>
        </Container>
        <ResponsiveContainer width={'100%'} height={'90%'}>
          <LineChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey={xDataKey} tick={{ fontSize: 12 }} />
            <YAxis width={40} tick={{ fontSize: 12 }}>
              {yLabel && <Label value={yLabel} offset={-10} angle={-90} position="left" />}
            </YAxis>
            <Tooltip />
            {showLegend && <Legend />}
            {lineDataKeys.map((item, index) => (
              <Line key={index} type="monotone" dataKey={item.dataKey} stroke={item.fill} dot={false} name={item.name} />
            ))}
          </LineChart>
        </ResponsiveContainer>
      </Container >
    </>
  );
};

export default LineGraph;
